import { generateTableSlice } from "./sliceTable";

const sliceHHAConfigTable = generateTableSlice("hhaConfig");

export const ActionsHHAConfigTable = sliceHHAConfigTable.actions;
export const ReducerHHAConfigTable = sliceHHAConfigTable.reducer;